import React from 'react';
import {
  ButtonWithGAClickButton,
  ModalHeader,
  Typography,
} from 'common/components';
import { ModalFooter, ModalContent } from 'fronton-react';

export const FreeProject = ({ elementBlock, onBtnClick }: { elementBlock: string; onBtnClick: () => void; }) => (
  <>
    <ModalHeader title="Бесплатный замер в черте города" />
    <ModalContent>
      <Typography adaptive={false} variant="m" size="body_long">
        Наш специалист подготовит расчет стоимости окон совершенно бесплатно: учтёт размеры,
        общий стиль интерьера и&nbsp;ваши пожелания&nbsp;&mdash; можно онлайн
        или в&nbsp;любом магазине Лемана ПРО.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        onClick={onBtnClick}
        elementBlock={elementBlock}
        elementName="Бесплатный замер в черте города"
        elementText="Записаться"
        fullWidth
        wide
      >
        Записаться
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
